import _sharedCjsProd from "./dist/shared.cjs.prod.js";
export { _sharedCjsProd as default };
export const __esModule = _sharedCjsProd.__esModule,
      EMPTY_ARR = _sharedCjsProd.EMPTY_ARR,
      EMPTY_OBJ = _sharedCjsProd.EMPTY_OBJ,
      NO = _sharedCjsProd.NO,
      NOOP = _sharedCjsProd.NOOP,
      PatchFlagNames = _sharedCjsProd.PatchFlagNames,
      babelParserDefaultPlugins = _sharedCjsProd.babelParserDefaultPlugins,
      camelize = _sharedCjsProd.camelize,
      capitalize = _sharedCjsProd.capitalize,
      def = _sharedCjsProd.def,
      escapeHtml = _sharedCjsProd.escapeHtml,
      escapeHtmlComment = _sharedCjsProd.escapeHtmlComment,
      extend = _sharedCjsProd.extend,
      generateCodeFrame = _sharedCjsProd.generateCodeFrame,
      getGlobalThis = _sharedCjsProd.getGlobalThis,
      hasChanged = _sharedCjsProd.hasChanged,
      hasOwn = _sharedCjsProd.hasOwn,
      hyphenate = _sharedCjsProd.hyphenate,
      invokeArrayFns = _sharedCjsProd.invokeArrayFns,
      isArray = _sharedCjsProd.isArray,
      isBooleanAttr = _sharedCjsProd.isBooleanAttr,
      isDate = _sharedCjsProd.isDate,
      isFunction = _sharedCjsProd.isFunction,
      isGloballyWhitelisted = _sharedCjsProd.isGloballyWhitelisted,
      isHTMLTag = _sharedCjsProd.isHTMLTag,
      isIntegerKey = _sharedCjsProd.isIntegerKey,
      isKnownAttr = _sharedCjsProd.isKnownAttr,
      isMap = _sharedCjsProd.isMap,
      isModelListener = _sharedCjsProd.isModelListener,
      isNoUnitNumericStyleProp = _sharedCjsProd.isNoUnitNumericStyleProp,
      isObject = _sharedCjsProd.isObject,
      isOn = _sharedCjsProd.isOn,
      isPlainObject = _sharedCjsProd.isPlainObject,
      isPromise = _sharedCjsProd.isPromise,
      isReservedProp = _sharedCjsProd.isReservedProp,
      isSSRSafeAttrName = _sharedCjsProd.isSSRSafeAttrName,
      isSVGTag = _sharedCjsProd.isSVGTag,
      isSet = _sharedCjsProd.isSet,
      isSpecialBooleanAttr = _sharedCjsProd.isSpecialBooleanAttr,
      isString = _sharedCjsProd.isString,
      isSymbol = _sharedCjsProd.isSymbol,
      isVoidTag = _sharedCjsProd.isVoidTag,
      looseEqual = _sharedCjsProd.looseEqual,
      looseIndexOf = _sharedCjsProd.looseIndexOf,
      makeMap = _sharedCjsProd.makeMap,
      normalizeClass = _sharedCjsProd.normalizeClass,
      normalizeStyle = _sharedCjsProd.normalizeStyle,
      objectToString = _sharedCjsProd.objectToString,
      parseStringStyle = _sharedCjsProd.parseStringStyle,
      propsToAttrMap = _sharedCjsProd.propsToAttrMap,
      remove = _sharedCjsProd.remove,
      slotFlagsText = _sharedCjsProd.slotFlagsText,
      stringifyStyle = _sharedCjsProd.stringifyStyle,
      toDisplayString = _sharedCjsProd.toDisplayString,
      toHandlerKey = _sharedCjsProd.toHandlerKey,
      toNumber = _sharedCjsProd.toNumber,
      toRawType = _sharedCjsProd.toRawType,
      toTypeString = _sharedCjsProd.toTypeString;